import { useState } from "react";
import { Link } from "react-router-dom";
import { ArrowRight, Trophy } from "lucide-react";
import { useMfTop, pct, tone, shortCat, navDate } from "@/lib/format";
import { terFmt } from "@/lib/amc";

export const FundLeaders = () => {
  const { data, isLoading } = useMfTop();
  const [tab, setTab] = useState(0);
  const leaders = data?.leaders || [];
  const cur = leaders[tab];
  return (
    <section data-testid="fund-leaders" className="bg-white border-y border-slate-200">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-12 md:py-20">
        <div className="flex flex-wrap items-end justify-between gap-4">
          <div>
            <p className="text-xs font-bold uppercase tracking-[0.18em] text-[#059669]">Mutual Fund Leaderboard</p>
            <h2 className="font-display text-2xl sm:text-3xl lg:text-4xl font-extrabold tracking-tight mt-2">Top performers by 3-year CAGR</h2>
            <p className="text-sm text-slate-500 mt-2">Direct-Growth plans · Computed from official AMFI NAVs as of {navDate(data?.nav_date)}</p>
          </div>
          <Link to="/mutual-funds" data-testid="leaders-view-all" className="inline-flex items-center gap-1.5 text-sm font-bold text-[#059669] hover:gap-2.5 transition-[gap]">Explore all funds <ArrowRight className="w-4 h-4" /></Link>
        </div>
        <div className="mt-8 flex gap-2 overflow-x-auto pb-1">
          {leaders.map((l, i) => (
            <button key={l.category} data-testid={`fund-tab-${shortCat(l.category).toLowerCase().replace(/\s/g, "-")}`} onClick={() => setTab(i)}
              className={`shrink-0 h-10 px-4 rounded-full text-sm font-semibold border transition-colors ${tab === i ? "bg-[#1E293B] text-white border-[#1E293B]" : "bg-white text-slate-600 border-slate-200 hover:border-slate-400"}`}>
              {shortCat(l.category)}
            </button>
          ))}
        </div>
        <div className="mt-6 overflow-x-auto rounded-2xl border border-slate-200">
          <table data-testid="leaders-table" className="w-full text-sm">
            <thead className="bg-[#F8FAFC] text-left text-xs uppercase tracking-wider text-slate-500">
              <tr><th className="px-4 py-3 w-12">#</th><th className="px-4 py-3">Fund</th><th className="px-4 py-3 text-right">NAV</th><th className="px-4 py-3 text-right">Expense</th><th className="px-4 py-3 text-right">1Y</th><th className="px-4 py-3 text-right">3Y CAGR</th><th className="px-4 py-3 text-right">5Y CAGR</th></tr>
            </thead>
            <tbody>
              {isLoading && <tr><td colSpan={7} className="px-4 py-10 text-center text-slate-400">Loading live AMFI data…</td></tr>}
              {cur?.funds.map((f, i) => (
                <tr key={f.code} data-testid={`leader-row-${f.code}`} className="border-t border-slate-100 hover:bg-emerald-50/40 transition-colors">
                  <td className="px-4 py-4">{i === 0 ? <Trophy className="w-5 h-5 text-amber-500" /> : <span className="font-mono text-slate-400">{i + 1}</span>}</td>
                  <td className="px-4 py-4"><Link to={`/mutual-funds/${f.code}`} className="font-semibold text-slate-900 hover:text-[#059669]">{f.name}</Link><p className="text-xs text-slate-500">{f.amc}</p></td>
                  <td className="px-4 py-4 text-right font-mono">₹{f.nav.toFixed(2)}</td>
                  <td className="px-4 py-4 text-right font-mono text-slate-500">{terFmt(f.ter)}</td>
                  <td className={`px-4 py-4 text-right font-mono ${tone(f.r1y)}`}>{pct(f.r1y)}</td>
                  <td className={`px-4 py-4 text-right font-mono font-bold ${tone(f.r3y)}`}>{pct(f.r3y)}</td>
                  <td className={`px-4 py-4 text-right font-mono ${tone(f.r5y)}`}>{pct(f.r5y)}</td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      </div>
    </section>
  );
};
